import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'mh-nps-widget',
    templateUrl: './nps-widget.component.html',
    styleUrls: ['./nps-widget.component.scss'],
    standalone: false
})
export class NpsWidgetComponent {
  @Input() value = 0;
  @Input() promoters = 0;
  @Input() passives = 0;
  @Input() detractors = 0;
  @Input() status = '';
  @Input() loading = false;
  @Input() hideViewMoreButton = false;

  @Output() downloadEbook = new EventEmitter<void>();
  @Output() viewMore = new EventEmitter<void>();

  onDownloadEbook(): void {
    this.downloadEbook.emit();
  }

  onViewMore(): void {
    this.viewMore.emit();
  }
}
